import { DropdownMenu } from '@heroui/react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const TopBarWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
`;

export const RightNav = styled.div` 
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    padding-right: 30px;
`;

export const DropdownWrapper = styled(DropdownMenu)` 
    border-radius: 6px;
`;

export const DropdownTriggerElement = styled.div`
    display: flex;
    cursor: pointer;
    font-size: 13px;
    align-items: center;
    justify-content: center;
`;

export const RightNavElement = styled(Link)`
    display: flex;
    gap: 15px;
    cursor: pointer;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    position: relative; 
    height: 45px;  
    &:hover {
        text-decoration: underline;
    }
`;

export const MobileNavigationHeadline = styled.div`
    width: auto;
    height: 100%;
    display: none;
    @media (max-width: 768px) {
     display: block;
    }
`;
